var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 15.5H27C27.2652 15.5 27.5196 15.6054 27.7071 15.7929C27.8946 15.9804 28 16.2348 28 16.5C28 16.7652 27.8946 17.0196 27.7071 17.2071C27.5196 17.3946 27.2652 17.5 27 17.5H7C6.73478 17.5 6.48043 17.3946 6.29289 17.2071C6.10536 17.0196 6 16.7652 6 16.5C6 16.2348 6.10536 15.9804 6.29289 15.7929C6.48043 15.6054 6.73478 15.5 7 15.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41383 16.5L15.7078 24.792C15.8956 24.9798 16.0011 25.2345 16.0011 25.5C16.0011 25.7656 15.8956 26.0203 15.7078 26.208C15.5201 26.3958 15.2654 26.5013 14.9998 26.5013C14.7343 26.5013 14.4796 26.3958 14.2918 26.208L5.29183 17.208C5.19871 17.1152 5.12482 17.0048 5.07441 16.8833C5.024 16.7618 4.99805 16.6316 4.99805 16.5C4.99805 16.3685 5.024 16.2383 5.07441 16.1168C5.12482 15.9953 5.19871 15.8849 5.29183 15.792L14.2918 6.79204C14.4796 6.60427 14.7343 6.49878 14.9998 6.49878C15.2654 6.49878 15.5201 6.60427 15.7078 6.79204C15.8956 6.97982 16.0011 7.23449 16.0011 7.50004C16.0011 7.76559 15.8956 8.02027 15.7078 8.20804L7.41383 16.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpBack);
export default __webpack_public_path__ + "static/media/ep_back.db2b6afe0d87e272bc6a9139f39f2573.svg";
export { ForwardRef as ReactComponent };